import { render, staticRenderFns } from "./diet-schedule-form.vue?vue&type=template&id=52f2979e&"
import script from "./diet-schedule-form.vue?vue&type=script&lang=js&"
export * from "./diet-schedule-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports